import React, { FC, useState, useEffect, useCallback } from 'react'
import { Button } from '@wmgtech/legato'

import { FilterBtnGroupProps } from './FilterButtonGroup.props'

import './FilterButtonGroup.scss'

const FilterButtonGroup: FC<FilterBtnGroupProps> = (props) => {
  const { onReset, reset, defaultValue, initialValue } = props
  const [filter, setFilter] = useState<string>('')

  useEffect(() => {
    if (initialValue) {
      setFilter(initialValue)
    }
  }, [initialValue])

  useEffect(() => {
    if (reset) {
      setFilter(defaultValue)
      onReset()
    }
  }, [reset, onReset, defaultValue])

  const selectValue = useCallback(
    (value: string) => () => {
      setFilter(value)
      props.onSelect(value)
    },
    [props]
  )

  return (
    <div className="filter-btn-group" role="group" aria-label="Basic radio toggle button group">
      {props.options.map((option: any) => (
        <Button
          key={`filterBtnGroupItem_${option.value}`}
          label={option.label}
          colorType="secondary-black"
          size="sm"
          data-test={`${props.dataTest}-option_${option.value}`}
          onClick={selectValue(option.value)}
          {...(option.value !== filter && { containerStyle: 'outline' })}
        />
      ))}
    </div>
  )
}

export default FilterButtonGroup
